// =============================================================================
// MAIN JAVASCRIPT - SISTEMA MODULAR
// =============================================================================

// Importar AOS
import AOS from 'aos';

// Módulos del sistema
import { CountdownTimer } from './modules/countdown.js';
import { GalleryManager } from './modules/gallery.js';
import { FormHandler } from './modules/forms.js';
import { AnimationManager } from './modules/animations.js';
import { DatabaseAPI, enhanceFormsWithDatabase } from './modules/database-api.js';

class RSVPApp {
    constructor() {
        this.config = window.RSVP_CONFIG || {};
        this.init();
    }

    init() {
        // Inicializar cuando el DOM esté listo
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initializeApp());
        } else {
            this.initializeApp();
        }
    }

    initializeApp() {
        console.log('🎉 Inicializando RSVP App...');

        // Inicializar AOS con configuración personalizada
        this.initAOS();

        // Inicializar módulos
        this.initCountdown();
        this.initGallery();
        this.initDatabase();
        this.initForms();
        this.initAnimations();

        // Efectos adicionales
        this.initScrollEffects();
        this.initLazyLoading();

        console.log('✅ RSVP App inicializada correctamente');
    }

    initAOS() {
        AOS.init({
            duration: 800,
            easing: 'ease-in-out',
            once: true,
            offset: 100,
            delay: 100,
            ...this.config.aos
        });

        // Refrescar AOS en cambios de tamaño de ventana
        window.addEventListener('resize', () => {
            AOS.refresh();
        });
    }

    initCountdown() {
        const countdownElement = document.getElementById('countdown');
        if (countdownElement && this.config.countdown) {
            new CountdownTimer(countdownElement, this.config.countdown);
        }
    }

    initGallery() {
        const galleryElements = document.querySelectorAll('.owl-carousel');
        if (galleryElements.length > 0) {
            new GalleryManager(galleryElements, this.config.gallery);
        }
    }

    initDatabase() {
        if (this.config.database && this.config.database.apiUrl) {
            this.databaseAPI = new DatabaseAPI(this.config.database);
            enhanceFormsWithDatabase(this.databaseAPI);
            
            // Hacer disponible globalmente para la página de administración
            window.DatabaseAPI = this.databaseAPI;
        }
    }

    initForms() {
        const formElements = document.querySelectorAll('.gform');
        if (formElements.length > 0) {
            new FormHandler(formElements, this.config.forms);
        }
    }

    initAnimations() {
        if (this.config.animations !== false) {
            new AnimationManager(this.config.animations);
        }
    }

    initScrollEffects() {
        // Efecto parallax suave para el hero
        // const hero = document.querySelector('.hero');
        // if (hero) {
        //     window.addEventListener('scroll', () => {
        //         const scrolled = window.pageYOffset;
        //         const rate = scrolled * -0.5;
        //         hero.style.transform = `translateY(${rate}px)`;
        //     });
        // }

        // Mostrar/ocultar elementos en scroll
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-view');
                }
            });
        }, observerOptions);

        document.querySelectorAll('[data-scroll-reveal]').forEach(el => {
            observer.observe(el);
        });
    }

    initLazyLoading() {
        // Lazy loading para imágenes
        const imageObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');
                    imageObserver.unobserve(img);
                }
            });
        });

        document.querySelectorAll('img[data-src]').forEach(img => {
            imageObserver.observe(img);
        });
    }
}

// Inicializar la aplicación
new RSVPApp();

// Exportar para uso global si es necesario
window.RSVPApp = RSVPApp;